import type { Nullable } from '@ats/interfaces';
import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';

export const currentSpeackerCheck = atom<Nullable<boolean>>(null);

export const currentCameraCheck = atom<Nullable<boolean>>(null);

export const isDeviceError = atomWithReset<boolean>(false);

export const isMeetingError = atomWithReset<boolean>(false);
